import * as axios from "axios";
import { getAuthHeader } from "./../utils";

export const applyLeaves = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}leaves/apply`;
  return axios.post(url, model, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};




export const updateStatus = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}leaves/update`;
  return axios.post(url, model, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const requestCancellation = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}leaves/request-cancellation`;
  return axios.post(url, model, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const manageCancellation = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}leaves/manage-cancellation`;
  return axios.post(url, model, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getLeavesList = (date: number) => {
  const url = `${process.env.REACT_APP_BASE_URL}leaves/list?date=${date}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getLeaveSummary = (year: number) => {
  const url = `${process.env.REACT_APP_BASE_URL}leaves/summary?year=${year}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getLeaveDetail = (code: string) => {
  const url = `${process.env.REACT_APP_BASE_URL}leaves/detail/${code}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const updateUserLeave = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}leaves-management/update`;
  return axios.post(url, model, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getUserLeaveSummary = (code: string) => {
  const url = `${process.env.REACT_APP_BASE_URL}leaves-management/user-leave-summary?uc=${code}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getLeaveReport = () => {
  const url = `${process.env.REACT_APP_BASE_URL}leaves-management/report`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getLeaveMonthlyLeaveReport = (
  startDate: string,
  endDate: string
) => {
  const url = `${process.env.REACT_APP_BASE_URL}leaves-management/search?sd=${startDate}&ed=${endDate}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const bulkUpdateBalance = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}leaves-management/bulk-update`;
  return axios.post(url, model, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getOrganisationLeaveRequest = (date: string) => {
  const url = `${process.env.REACT_APP_BASE_URL}leaves-management/organisation-request?dt=${date}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getOrganisationEncashmentRequest = (date: string) => {
  const url = `${process.env.REACT_APP_BASE_URL}encashment-management/organisation-request?dt=${date}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getLeaveBalanceUpdateLog = () => {
  const url = `${process.env.REACT_APP_BASE_URL}leaves-management/balance-update/log`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};
